import React from 'react'
import {
  Paper,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Radio,
} from '@mui/material'

function FilterBar(_props) {
  const { presets = [], children, ...presetsGroupProps } = _props

  const FilterPresets = React.useCallback(() => {
    if (presets.length === 0) {
      return null
    }
    return (
      <FormControl>
        <RadioGroup
          className="flex flex-row gap-8 items-center justify-start p-5"
          {...presetsGroupProps}
        >
          {presets.map((preset, index) => (
            <FormControlLabel {...preset} control={<Radio />} key={index} />
          ))}
        </RadioGroup>
      </FormControl>
    )
  }, [presets,_props.value])

  return (
    <Paper
      elevation={0}
      className="bg-gray1 flex flex-row justify-start items-center"
    >
      <FilterPresets />
      {_props.children}
    </Paper>
  )
}

export default FilterBar
